











































































































import Vue from "vue";
// @ts-ignore
import { Form } from "element-ui";
import { axios } from "@/plugins";
import { mapState } from "vuex";

export default Vue.extend({
  name: "ConfigsEdit",
  props: { projectId: { type: String }, userinfo: { type: Object } },
  data() {
    const checkData = (
      rule: any,
      value: any,
      callback: (err?: string) => {}
    ) => {
      if (!(Object.keys((this as any).ruleForm.data).length > 0)) {
        callback("data不能为空");
      }
      callback();
    };
    return {
      dialog: false,
      isEdit: false,
      editValue: false,
      loading: false,
      // 键值对输入框对应值
      key: "",
      value: "",

      ruleForm: {
        name: "",
        description: "",
        data: {} as any,
        creator: ""
      },
      rules: {
        name: [
          { required: true, type: "string", pattern: /^(?!-)[a-z0-9-]*[^-]$/ }
        ],
        data: [{ required: true, validator: checkData, trigger: "blur" }]
      }
    };
  },
  computed: {
    ...mapState("LoginInfo", ["project"]),
    list() {
      return Object.entries((this as any).ruleForm.data);
    }
  },
  methods: {
    show(data?: any) {
      if (data) {
        const formData = JSON.parse(JSON.stringify(data));
        // 编辑模式
        // @ts-ignore
        this.ruleForm.name = formData.metadata.name;
        // @ts-ignore
        this.ruleForm.description =
          formData.metadata.annotations &&
          formData.metadata.annotations["appmgr.object.description"];
        // @ts-ignore
        this.ruleForm.creator =
          formData.metadata.annotations &&
          formData.metadata.annotations["appmgr.object.createBy"];
        // @ts-ignore
        this.ruleForm.data = { ...formData.data };
        // @ts-ignore
        this.isEdit = true;
      } else {
        // @ts-ignore
        this.ruleForm.creator = this.userinfo.username;
        // @ts-ignore
        this.isEdit = false;
      }
      // @ts-ignore
      this.dialog = true;
    },
    // 键值对 添加到 data
    addKvData() {
      // @ts-ignore
      if (!this.key || !this.value) {
        this.$message.error("键值对的不能为空");
        return;
      }
      // @ts-ignore
      this.$set(this.ruleForm.data, this.key, this.value);
      // @ts-ignore
      this.key = this.value = "";
    },
    // 键值对 删除 某项
    delKvData(key: string) {
      // @ts-ignore
      delete this.ruleForm.data[key];
      // 此处浅拷贝是为了触发页面刷新
      // @ts-ignore
      this.ruleForm = Object.assign({}, this.ruleForm);
    },
    quit() {
      // @ts-ignore
      this.key = this.value = "";
      // @ts-ignore
      this.editValue = false;
      // @ts-ignore
      this.ruleForm = (this as any).$options.data().ruleForm;
      (this.$refs.ruleForm as Form).resetFields();
      // @ts-ignore
      this.dialog = false;
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          // @ts-ignore
          this.loading = true;
          // @ts-ignore
          if (this.isEdit) {
            // @ts-ignore
            this.edit();
          } else {
            // @ts-ignore
            this.create();
          }
        }
      });
    },
    edit() {
      axios
        // @ts-ignore
        .put(`/configmap/${this.projectId}`, this.buildData())
        .then(() => {
          this.$message.success("配置修改成功");
          // @ts-ignore
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          // @ts-ignore
          this.loading = false;
        });
    },
    create() {
      axios
        // @ts-ignore
        .post(`/configmap/${this.projectId}`, this.buildData())
        .then(() => {
          this.$message.success("配置创建成功");
          // @ts-ignore
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          // @ts-ignore
          this.loading = false;
        });
    },
    // 构建接口数据类型
    buildData() {
      // @ts-ignore
      const { name, description, data, creator } = this.ruleForm;

      const formData = JSON.parse(JSON.stringify(data));
      // for (const key in formData) {
      //   formData[key] = formData[key].replace(/"/g, '\\"');
      // }
      const resData = {
        metadata: {
          name,
          namespace: this.project.tenantCode + "-" + this.project.projectName,
          annotations: {
            "appmgr.object.createBy": creator,
            "appmgr.object.description": description
          }
        },
        kind: "ConfigMap",
        apiVersion: "v1"
      };
      return {
        ...resData,
        data: formData
      };
    }
  }
});
